
















import { mapGetters } from "vuex";
import { Component, Mixins, Prop } from "vue-property-decorator";
import TermsAndConditionsMixin from "@/components/app/global/termsAndConditions/termsAndConditionsMixin";
import i18n from "@/i18n";

@Component({
  computed: {
    ...mapGetters({
      brandName: "brand/name"
    })
  }
})
export default class TermsAndConditionsStatement extends Mixins(
  TermsAndConditionsMixin
) {
  // Map getters

  private brandName!: string;

  // Props

  @Prop({ default: () => i18n.t("_action.continue") })
  public readonly label!: string;

  // Get terms URL (if specified)
  public get termsUrl() {
    return this.$_.get(this.current, "terms.url", null);
  }

  // Get terms text (if specified)
  public get termsText() {
    return this.$_.get(this.current, "terms.terms", null);
  }

  // Open terms modal
  public openTermsModal() {
    this.$store.dispatch("ui/open/windowModal", {
      config: {
        component: () =>
          import(
            "@/components/app/admin/settings/billing/termsAndContitionsModal.vue"
          ),
        props: {
          allowCopy: false,
          termsId: "current"
        }
      }
    });
  }
}
